var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperScroll(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.949,2A2.5,2.5,0,0,0,17.5,0H5.5A2.5,2.5,0,0,0,3,2.5V15H.5a.5.5,0,0,0-.5.5v2A2.5,2.5,0,0,0,2.5,20h11A2.5,2.5,0,0,0,16,17.5V5h3.5a.5.5,0,0,0,.5-.5v-2A2.462,2.462,0,0,0,19.949,2ZM5.5,19h-3A1.5,1.5,0,0,1,1,17.5V16H11v1.5a2.491,2.491,0,0,0,.5,1.5ZM15,17.5a1.5,1.5,0,0,1-3,0v-2a.5.5,0,0,0-.5-.5H4V2.5A1.5,1.5,0,0,1,5.5,1H15.511A2.482,2.482,0,0,0,15,2.5v15ZM19,4H16V2.5a1.5,1.5,0,0,1,3,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperScroll);
export default __webpack_public_path__ + "static/media/PaperScroll.3005105f8f4835c47754e0191df819e7.svg";
export { ForwardRef as ReactComponent };